
export default {
  props: {
    pre: {
      type: String,
      required: true
    },
    post: {
      type: String,
      required: true
    }
  }
}
